import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import ReactTooltip from 'react-tooltip';
import Loading from '../general/Loading.js';
import Search from '../general/Search.js';
import GeneralTd from '../table-componets/GeneralTd.js';
import EmailTd from '../table-componets/EmailTd.js';
import PhoneNumberTd from '../table-componets/PhoneNumberTd.js';
import ButtonTd from '../table-componets/ButtonTd.js';
import ExportButton from '../ExportButton';

class Members extends React.Component {
  state = {
    searchText: '',
    memberTypeFilter: '',
    page: 1,
    perPage: 20,
    totalPages: 1,
    orderBy: 'last_name',
    orderDir: 'ASC',
    members: [],
    loading: true
  };

  componentDidMount() {
    this.buildData();
  }

  buildData() {
    var that = this;
    var params = {
      page: this.state.page,
      per_page: this.state.perPage,
      order_by: this.state.orderBy,
      order_dir: this.state.orderDir,
      method: 'formatted_phone_number,avatar_url'
    };

    if (this.state.searchText) {
      params['search'] = this.state.searchText;
    }
    if (this.state.memberTypeFilter) {
      params['member_type_id'] = this.state.memberTypeFilter
    }

    axios({
      method: 'get',
      url: '/members.json',
      params: params,
      responseType: 'json'
    }).then(function(response) {
      that.setState({ loading: false });
      that.setState({ members: response.data });
      that.setState({
        totalPages: Math.ceil(response.headers.total / that.state.perPage)
      });
    });
  }

  newSearch(newSearch) {
    this.setState({ searchText: newSearch });
    this.setState({ page: 1 });
    this.buildData();
  }

  handleMemberTypeChange(event) {
    this.setState({
      page: 1,
      memberTypeFilter: event.target.value,
      loading: true
    }, () => {
      this.buildData();
    })
  }

  sortData(orderBy) {
    if (orderBy == this.state.orderBy) {
      if (this.state.orderDir == 'DESC') {
        this.setState({ orderDir: 'ASC' });
      } else {
        this.setState({ orderDir: 'DESC' });
      }
    } else {
      this.setState({ orderBy: orderBy });
      this.setState({ orderDir: 'DESC' });
    }

    setTimeout(
      function() {
        this.buildData();
      }.bind(this),
      50
    );
  }

  changePage(increment) {
    var page = this.state.page + increment;
    this.setState({ page: page });
    setTimeout(
      function() {
        this.buildData();
      }.bind(this),
      50
    );
  }

  renderPagination() {
    return (
      <div>
        <p>
          {'Showing page ' + this.state.page + ' of ' + this.state.totalPages}
        </p>
        {this.state.page == 1 && (
          <a className="btn btn-default disabled">
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_left
            </i>
          </a>
        )}
        {this.state.page != 1 && (
          <button className="btn btn-default" onClick={() => this.changePage(-1)}>
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_left
            </i>
          </button>
        )}
        {this.state.page < this.state.totalPages && (
          <button className="btn btn-default" onClick={() => this.changePage(1)}>
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_right
            </i>
          </button>
        )}
        {this.state.page == this.state.totalPages && (
          <a className="btn btn-default disabled">
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_right
            </i>
          </a>
        )}
      </div>
    );
  }

  getMemberRole(role) {
    switch(role){
      case 0:
        return "Adult";
      case 1:
        return "Child";
      default:
        return "";
    }
  }

  renderImg(member) {
    return (
      <img
        src={member.avatar_url}
        style={{ height: '32px', width: '32px' }}
        className="img-circle"
        alt={member.first_name}
      />
    );
  }

  renderAllergiesIcon(allergies) {
    return (
      <span data-tip={'Allergies: ' + allergies}>
        <i className={'material-icons icon-for-nav indigo-text'}>
          local_hospital
        </i>
        <ReactTooltip />
      </span>
    );
  }

  renderBody() {
    var that = this;
    var members = [];

    _.forEach(this.state.members, function(member, index) {
      members.push(
        <tr key={index}>
          <td>
            <a className="styled-link" href={'/members/' + member.id}>
              {that.renderImg(member)}
            </a>
          </td>
          <td>
            <span className="margin-right-five">{member.last_name}</span>

            {member.imported_household_id && (
              <span
                className="margin-right-five"
                data-tip="Imported Household ID"
              >
                {'(' + member.imported_household_id + ')'}
                <ReactTooltip />
              </span>
            )}

            {member.imported_member_id && (
              <span className="margin-right-five" data-tip="Imported Member ID">
                {'(' + member.imported_member_id + ')'}
                <ReactTooltip />
              </span>
            )}

            {member.primary && (
              <span data-tip="Primary member of household">
                <span className="badge">Primary</span>
                <ReactTooltip />
              </span>
            )}

            {member.allergies && (
              <span>{that.renderAllergiesIcon(member.allergies)}</span>
            )}
          </td>
          <GeneralTd fieldValue={member.first_name} />
          <GeneralTd
            fieldValue={that.getMemberRole(member.role)}
            fieldClassName="hidden-xs"
          />
          <EmailTd fieldValue={member.email} fieldClassName="hidden-xs" />
          <PhoneNumberTd
            fieldValue={member.formatted_phone_number}
            fieldClassName="hidden-xs"
          />
          <ButtonTd fieldName="VIEW" fieldURL={'/members/' + member.id} />
        </tr>
      );
    });

    return <tbody>{members}</tbody>;
  }

  render() {
    var that = this;

    return (
      <div>
        <h1>Members</h1>
        <div className="row">
          <div className="col-md-3 col-xs-12">
            <select
              id={'selectMemberTypeId'}
              className="form-control"
              name='member_type_id'
              value={this.state.memberTypeFilter}
              onChange={() => this.handleMemberTypeChange(event)}
            >
              {this.props.memberTypeOptions.map(option => (
                <option key={`option${option[0]}`} value={option[0]}>
                  {option[1]}
                </option>
              ))}
            </select>
          </div>
          <Search newSearchCallback={newSearch => this.newSearch(newSearch)} />
          <div className="col-md-6 pull-right">
            <div className="pull-right">
              <a
                className="btn btn-pink btn-raised btn-long margin-right-five"
                href="/households/new"
              >
                ADD
              </a>
              <a
                className="btn btn-indigo btn-raised btn-long margin-right-five"
                href="/households"
              >
                HOUSEHOLDS
              </a>
              <button
                className="btn btn-grey btn-raised btn-long dropdown-toggle hidden-xs hidden-sm"
                data-toggle="dropdown"
              >
                <span className="margin-right-five">OPTIONS</span>
                <span className="caret" />
              </button>
              <ul className="dropdown-menu">
                <li>
                  <a href="/members_importer">IMPORT</a>
                  <ExportButton url="/export/households" />
                </li>
              </ul>
              <br className="visible-xs visible-sm" />
            </div>
          </div>
        </div>
        <br />
        {that.state.members.length ? (
          <div>
            <table className="table table-clean table-white">
              <thead>
                <tr>
                  <th />
                  <th>
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData('last_name'); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Last Name"
                      tabIndex="0"
                      onKeyDown={(e) => { 
                        if (e.key === 'Enter' || e.key === ' ') { 
                          e.preventDefault();
                          this.sortData('last_name'); 
                        }
                      }}
                    >
                      Last Name
                    </a>
                  </th>

                  <th>
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData('first_name'); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by First Name"
                      tabIndex="0"
                      onKeyDown={(e) => { 
                        if (e.key === 'Enter' || e.key === ' ') { 
                          e.preventDefault();
                          this.sortData('first_name'); 
                        }
                      }}
                    >
                      First Name
                    </a>
                  </th>

                  <th className="hidden-xs">
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData('role'); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Role"
                      tabIndex="0"
                      onKeyDown={(e) => { 
                        if (e.key === 'Enter' || e.key === ' ') { 
                          e.preventDefault();
                          this.sortData('role'); 
                        }
                      }}
                    >
                      Role
                    </a>
                  </th>

                  <th className="hidden-xs">
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData('email'); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Email"
                      tabIndex="0"
                      onKeyDown={(e) => { 
                        if (e.key === 'Enter' || e.key === ' ') { 
                          e.preventDefault();
                          this.sortData('email'); 
                        }
                      }}
                    >
                      Email
                    </a>
                  </th>

                  <th className="hidden-xs">
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData('phone_number'); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Phone Number"
                      tabIndex="0"
                      onKeyDown={(e) => { 
                        if (e.key === 'Enter' || e.key === ' ') { 
                          e.preventDefault();
                          this.sortData('phone_number'); 
                        }
                      }}
                    >
                      Phone Number
                    </a>
                  </th>

                  <th />
                </tr>
              </thead>
              {this.renderBody()}
            </table>
            {this.renderPagination()}
          </div>
        ) : (
          <Loading loading={this.state.loading} noDataMessage="No members" />
        )}
      </div>
    );
  }
}

export default Members;
